import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F1493F",
  d: "M19.238 11.813a7.808 7.808 0 0 0-1.863-2.589l-.654-.6a.182.182 0 0 0-.292.075l-.292.837c-.182.527-.516 1.064-.99 1.591a.14.14 0 0 1-.092.045.123.123 0 0 1-.097-.034.132.132 0 0 1-.045-.107c.083-1.353-.321-2.879-1.207-4.54-.733-1.379-1.75-2.455-3.022-3.206l-.928-.545a.18.18 0 0 0-.27.164l.05 1.078c.033.737-.052 1.39-.254 1.93a6.417 6.417 0 0 1-1.056 1.832A6.642 6.642 0 0 1 7.158 8.78a7.924 7.924 0 0 0-2.254 2.73 7.814 7.814 0 0 0-.19 6.524 7.897 7.897 0 0 0 4.21 4.17 7.908 7.908 0 0 0 3.077.616 7.951 7.951 0 0 0 3.076-.614c.939-.39 1.793-.96 2.514-1.678a7.78 7.78 0 0 0 2.32-5.548 7.737 7.737 0 0 0-.673-3.167Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }